// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__j13rn","footer__logo":"footer_footer__logo__jF+vN"};